// SA8000Certification.jsx
import React from "react";

export default function SA8000Certification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            SA8000 Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides expert assistance for SA8000 Certification, helping organizations comply with internationally recognized standards for social accountability, ethical workplace practices, and labor rights.
          </p>
          <p className="text-gray-700">
            Complete certification preparation including gap analysis, Social Fingerprint assessment, management system implementation, internal audits, and Stage 1/Stage 2 certification audits by accredited bodies.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Social accountability and ethical workplace compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="SA8000 certification social accountability compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless SA8000 certification audits and compliance verification.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Organizational and business registration details</li>
                <li>Human resource policies and procedures</li>
                <li>Employment records and wage details</li>
                <li>Health and safety documentation</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven track record of successful SA8000 certifications across manufacturing, textiles, and service sectors with comprehensive audit preparation.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Social Accountability Standards
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete SA8000:2014 knowledge covering child labor prohibition, forced labor prevention, health & safety management, freedom of association, discrimination prevention, disciplinary practices, working hours, and remuneration compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Compliance and Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise social manual preparation, management system procedures, grievance mechanisms, Social Committee setup, training records, internal audit programs, corrective action plans, and management review documentation ensuring audit readiness.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Guidance Throughout Certification
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from gap analysis through Stage 1/Stage 2 audits, Social Fingerprint evaluation, CB selection, mock audits, non-conformance closure, surveillance audit preparation, and recertification support with continuous improvement advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
